import { LRUMap } from 'lru_map';
export function createServicesCache() {
  return new LRUMap(100);
}